export default __webpack_public_path__ + "static/media/Group 4410.23f292d9.svg";